import gql from "graphql-tag";

export const UPDATE_USER_PROFILE = gql`
  mutation updateUserProfile($input: UpdatePublicProfileInput!){
    updatePublicProfile(input: $input) {
      clientMutationId
    }
  }
` 